import { render, staticRenderFns } from "./SchedaProdotto.vue?vue&type=template&id=6f13dd9e&scoped=true"
import script from "./SchedaProdotto.vue?vue&type=script&lang=js"
export * from "./SchedaProdotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13dd9e",
  null
  
)

export default component.exports